import { render } from "./profile.vue?vue&type=template&id=2a3baf68&scoped=true"
import script from "./profile.vue?vue&type=script&lang=ts"
export * from "./profile.vue?vue&type=script&lang=ts"

import "./profile.vue?vue&type=style&index=0&id=2a3baf68&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2a3baf68"

export default script